import { CheckUrgentTask, KeepOnlineForm } from "../types/trigger";
import { authFetcher } from "./../utils/auth-fetch";

const keepOnline = async (data: KeepOnlineForm) => {
  return await authFetcher<any>("POST", "keep-online", data);
};

const checkUrgentTask = async () => {
  return await authFetcher<CheckUrgentTask>("GET", "check-urgent-task");
};

export { checkUrgentTask, keepOnline };
